var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.86 22.6201C5.70996 22.6201 0.709961 17.6201 0.709961 11.4701C0.709961 5.32006 5.70996 0.320068 11.86 0.320068C18.01 0.320068 23.01 5.32006 23.01 11.4701C23.01 17.6201 18.01 22.6201 11.86 22.6201ZM11.86 1.10007C6.13996 1.10007 1.48996 5.75006 1.48996 11.4701C1.48996 17.1901 6.13996 21.8401 11.86 21.8401C17.58 21.8401 22.23 17.1901 22.23 11.4701C22.23 5.75006 17.58 1.10007 11.86 1.10007ZM11.86 18.4101C8.02996 18.4101 4.91996 15.3001 4.91996 11.4701C4.91996 7.64006 8.02996 4.53006 11.86 4.53006C15.69 4.53006 18.8 7.64006 18.8 11.4701C18.8 15.3001 15.69 18.4101 11.86 18.4101ZM11.86 5.30006C8.45996 5.30006 5.68996 8.07006 5.68996 11.4701C5.68996 14.8701 8.45996 17.6401 11.86 17.6401C15.26 17.6401 18.03 14.8701 18.03 11.4701C18.03 8.07006 15.26 5.30006 11.86 5.30006Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.86 18.0301C9.94996 18.0301 8.21996 17.2101 7.01996 15.9001L3.70996 18.5101C5.67996 20.7901 8.59996 22.2401 11.85 22.2401C15.94 22.2401 19.49 19.9601 21.31 16.6101L17.52 14.7701C16.38 16.7201 14.27 18.0401 11.85 18.0401L11.86 18.0301Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8599 4.92009C12.0199 4.92009 12.1799 4.92009 12.3399 4.94009V0.730087C12.1799 0.730087 12.0199 0.720093 11.8599 0.720093C11.6999 0.720093 11.5399 0.720087 11.3799 0.730087V4.94009C11.5399 4.93009 11.6999 4.92009 11.8599 4.92009Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43012 15.1401L3.12012 17.7501C3.31012 18.0101 3.51012 18.2701 3.72012 18.5101L7.03012 15.9001C6.81012 15.6601 6.61012 15.4101 6.43012 15.1401Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9503 13.8901C17.8303 14.1901 17.6903 14.4801 17.5303 14.7601L21.3203 16.6001C21.4703 16.3201 21.6103 16.0301 21.7403 15.7301L17.9503 13.8901Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.036b8ad7c716fb213fbb975e8c53e14c.svg";
export { ForwardRef as ReactComponent };